<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, TEXT_FONT_FAMILY} from '../../../../../components/Data/FactorCharts/chartStyle'

export default {
  name: 'VOCsCategorySiteBarChart',
  props: {
    data: {
      required: true,
      type: Array
    }
  },
  methods: {
    render ({factorGroups, dataTimes, chartTitle, unit}) {
      let {data} = this
      // let xAxisData = data.map(({siteName}) => dataTimes.map(dataTime => `${siteName} ${dataTime}`)).flat()
      // let xAxisData = data.map(() => dataTimes).flat()
      // let chartOpt = {
      //   title: {
      //     text: chartTitle,
      //     left: 'center',
      //     textStyle: {
      //       fontFamily: TEXT_FONT_FAMILY
      //     }
      //   },
      //   toolbox: {
      //     feature: {
      //       saveAsImage: {}
      //     },
      //     right: 23
      //   },
      //   tooltip: {
      //     trigger: 'axis'
      //   },
      //   legend: {
      //     top: 27,
      //     left: 'center',
      //     width: '75%',
      //     type: 'scroll'
      //   },
      //   grid: [{
      //     top: 75,
      //     right: 40,
      //     bottom: 45,
      //     left: 30,
      //     containLabel: true
      //   }],
      //   xAxis: [{
      //     type: 'category',
      //     data: xAxisData,
      //     axisLine: {
      //       show: true,
      //       lineStyle: AXIS_LINE_STYLE
      //     },
      //     axisLabel: {
      //       ...AXIS_LABEL,
      //       fontFamily: TEXT_FONT_FAMILY,
      //       rotate: 90
      //     },
      //     axisTick: {
      //       show: false,
      //       alignWithLabel: true
      //     }
      //   }, {
      //     type: 'category',
      //     data: data.map(data => data.siteName),
      //     axisLine: {
      //       show: false
      //     },
      //     axisLabel: {
      //       ...AXIS_LABEL,
      //       fontFamily: TEXT_FONT_FAMILY
      //     },
      //     axisTick: {
      //       show: false,
      //       alignWithLabel: true
      //     },
      //     axisPointer: {
      //       show: false
      //     },
      //     gridIndex: 0,
      //     position: 'bottom',
      //     offset: 80
      //   }],
      //   yAxis: {
      //     type: 'value',
      //     name: unit,
      //     axisLine: {
      //       show: false
      //       // lineStyle: AXIS_LINE_STYLE
      //     },
      //     axisLabel: {
      //       ...AXIS_LABEL,
      //       fontFamily: TEXT_FONT_FAMILY
      //     }
      //   },
      //   series: factorGroups.map(factorGroup => {
      //     let factorGroupId = factorGroup.id
      //
      //     return {
      //       id: factorGroupId,
      //       name: factorGroup.name,
      //       type: 'bar',
      //       stack: 'bar',
      //       barMaxWidth: 30,
      //       data: data.reduce((list, data) => {
      //         data = data.data
      //
      //         return dataTimes.reduce((list, dataTime) => {
      //           let value = data[dataTime][factorGroupId]
      //           list.push(Number.isFinite(value) ? Number(value.toFixed(3)) : null)
      //           return list
      //         }, list)
      //       }, [])
      //     }
      //   })
      // }

      let chartOpt = {
        title: {
          text: chartTitle,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'item',
          formatter: ({marker, name, seriesName, data}) => `<div>${name}${data.isHaveIntegral ? '(重积分)' : ''}</div><div>${marker}<span">${seriesName}</span><span style="padding-left:2em">${data.oVal === null ? '--' : data.value}</span></div>`
        },
        legend: {
          top: 27,
          left: 'center',
          width: '75%',
          type: 'scroll'
        },
        grid: [{
          top: 75,
          right: 40,
          bottom: 0,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: data.map(data => data.siteName),
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'value',
          name: unit,
          axisLine: {
            show: false
            // lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        series: dataTimes.reduce((list, dataTime) => factorGroups.reduce((list, factorGroup, index) => {
          let factorGroupId = factorGroup.id

          list.push({
            name: factorGroup.name,
            type: 'bar',
            stack: dataTime,
            barMaxWidth: 30,
            data: data.map(data => {
              let temp = data.data[dataTime][factorGroupId]
              let oVal = temp

              if (temp && Number.isFinite(temp.value)) {
                temp.value = Number(temp.value.toFixed(3))
              } else {
                temp = {
                  isHaveIntegral: false,
                  value: 0
                }
                oVal = null
              }
              return {
                ...temp,
                oVal
              }
            }),
            label: {
              show: true,
              formatter: index === 0 ? dataTime : '',
              color: '#333',
              position: 'inside',
              rotate: 90,
              offset: [Math.round(dataTime.length * 9 / 2), 0]
            }
          })

          return list
        }, list), [])
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/03VOCs-Category-Compare/VOCsCategorySiteBarChart.vue